import React from "react";
import FamilyBreadCrumb from "../../containers/Search/FamilyBreadCrumb";
import PropTypes from "prop-types";

const QuickSearchResultRenderer = (props) => {
  const {
    secondaryGrpDisplayName,
    tertiaryGrpDisplayName,
    productFamilyDisplayName,
    name: stockDescription,
    barcode: stockCode,
    alternativeBarcodes,
  } = props;
  return (
    <div key={stockDescription}>
      <div>
        <b>({stockCode}) </b> {stockDescription}
        {alternativeBarcodes?.length > 0 && (
          <div style={{ paddingTop: 5 }}>
            <span style={{ color: "grey" }}>
              Alternative Codes:{" "}
              {alternativeBarcodes?.map((altCode, index) => {
                if (index === 0) {
                  return `${altCode}`;
                } else {
                  return `, ${altCode}`;
                }
              })}
            </span>
          </div>
        )}
      </div>
      {(secondaryGrpDisplayName ||
        tertiaryGrpDisplayName ||
        productFamilyDisplayName) && (
        <div>
          <FamilyBreadCrumb
            key={stockCode}
            {...{
              secondaryGrpDisplayName,
              tertiaryGrpDisplayName,
              productFamilyDisplayName,
            }}
          />{" "}
        </div>
      )}
      {(secondaryGrpDisplayName ||
        tertiaryGrpDisplayName ||
        productFamilyDisplayName) && (
        <div>
          <FamilyBreadCrumb
            key={stockCode}
            {...{
              secondaryGrpDisplayName,
              tertiaryGrpDisplayName,
              productFamilyDisplayName,
            }}
          />{" "}
        </div>
      )}
    </div>
  );
};

QuickSearchResultRenderer.propTypes = {
  stockDescription: PropTypes.string,
  stockCode: PropTypes.string,
  secondaryGrp: PropTypes.string,
  tertiaryGrp: PropTypes.string,
  productFamily: PropTypes.string,
};

export default QuickSearchResultRenderer;
